module.exports = __webpack_public_path__ + "static/media/wallet.5d1d97da.svg";